<template>
  <div class="container">
    <div>
      <el-form ref="searchForm" :model="forms" class="search-form">
        <el-form-item label="用劵用户ID">
        <el-input
          v-model="forms.fansId"
          placeholder="用劵用户ID"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="优惠券名称">
        <el-input
          v-model="forms.couponName"
          placeholder="优惠券名称"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="领券时间">
        <el-date-picker
          v-model="forms.receiveTimeArr"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="至"
          start-placeholder="领券开始日期"
          end-placeholder="领券结束日期"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeTimesValue"
        >
        </el-date-picker>
        </el-form-item>
        <el-form-item label="优惠券状态">
        <el-select v-model="forms.couponStatus" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="用券订单号">
        <el-input
          v-model="forms.orderId"
          placeholder="用券订单号"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="用券时间">
        <el-date-picker
          v-model="forms.useTimeArr"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="至"
          start-placeholder="用券开始日期"
          end-placeholder="用券结束日期"
          :default-time="['00:00:00', '23:59:59']"
          @change="changeTimesValueEnd"
        >
        </el-date-picker>
        </el-form-item>
        <el-form-item>
        <el-button type="warning" @click="search">查询</el-button>
        <el-button type="warning" plain @click="reset">重置</el-button>
        <el-button @click="exportTable">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table 
      v-loading="loadingDy"
      :data="dyTableList.list"
      border
      highlight-current-row
      style="width: 100%"
      header-row-class-name="header"
    >
      <el-table-column
        v-for="(item, index) in tableDataDy"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
        :width="
          [
            'receiveTimeStr',
            'useTimeStr'
          ].includes(item.value)
            ? 170
            : '' || ['couponStatus'].includes(item.value) ? 90 : '' || ['couponName','orderId'].includes(item.value) ? 250 : ''
        "
      >
        <template slot-scope="{ row }">
          <span
            v-if="item.value === 'couponStatus'"
            class="status"
            :class="row.couponStatus == 10 ? 'green' : ''"
          >
            {{row.couponStatusStr}}
          </span>
          <span v-else>{{ row[item.value] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="dyTableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="dyTableList.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="dyTableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="dyTableList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {formatDate} from '@/utils/tool.js'
import { tableColumnUseDy } from "./enum";
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  data() {
    return {
      loadingDy:false,
      tableDataDy:tableColumnUseDy,
      dyTableList:{},
      searchForm:{
        pageSize: 10,
        pageNo: 1,
      },
      forms: {
        fansId: "",
        couponName: "",
        receiveTimeArr: "",
        couponStatus: "",
        orderId: "",
        useTimeArr: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "10",
          label: "待使用",
        },
        {
          value: "20",
          label: "已使用",
        },
      ],
    };
  },
  methods: {
    changeTimesValue(e) {
      console.log(e, "ee=1");
    },
    changeTimesValueEnd(e) {
      console.log(e, "ee=2");
    },
    search() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      this.getDyList()
    },
    reset() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      this.forms.fansId = ''
      this.forms.couponName = ''
      this.forms.couponStatus = ''
      this.forms.orderId = ''
      this.forms.receiveTimeArr = ""
      this.forms.useTimeArr = ""
      this.getDyList()
    },
    init() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      // this.reset()
      this.getDyList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val;
      this.getDyList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val;
      this.getDyList();
    },
    // 抖音-优惠券使用情况列表
    async getDyList() {
      console.log(this.forms,'forms')
      let params = {
        pageNo:this.searchForm.pageNo,
        pageSize:this.searchForm.pageSize,
        fansId:this.forms.fansId,
        couponName:this.forms.couponName,
        // receiveTimeStart:this.forms.receiveTimeArr[0],
        // receiveTimeEnd:this.forms.receiveTimeArr[1],
        couponStatus:this.forms.couponStatus,
        orderId:this.forms.orderId,
        // useTimeStart:this.form.useTimeArr[0],
        // useTimeEnd:this.form.useTimeArr[1],
      }
      console.log('ertt==11')
      params.receiveTimeStart = this.forms.receiveTimeArr ? this.forms.receiveTimeArr[0] : ''
      params.receiveTimeEnd = this.forms.receiveTimeArr ? this.forms.receiveTimeArr[1] : ''
      params.useTimeStart = this.forms.useTimeArr ? this.forms.useTimeArr[0] : ''
      params.useTimeEnd = this.forms.useTimeArr ? this.forms.useTimeArr[1] : ''
      console.log(params,'params')
      // this.dyTableList = {}
      // return
      this.loadingDy = true
      const res = await MiniModel.dyCouponUseSearch(params).finally(()=> {
        this.loadingDy = false
      })
      console.log(res,'抖音-优惠券使用情况列表')
      if(res.data.code == 200) {
        this.dyTableList = res.data.data
        console.log(this.dyTableList,'this.dyTableList')
      }else{
        this.dyTableList = []
      }
    },
    async exportTable() {
      const res = await MiniModel.useSearchExportDy()
      console.log(res,'导出')
      if(res.status == 200) {
        const blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "抖音优惠券使用情况导出_" + formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
  }
};
</script>

<style lang="less" scoped>
/deep/.el-range-separator {
  width: 10% !important;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
.status {
  display: block;
  position: relative;
  &::before {
    content: "";
    float: left;
    width: 6px;
    height: 6px;
    background: #ff8622;
    border-radius: 50%;
    margin-top: 8px;
  }
  &.green::before {
    background: #51c456;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDy/couponDyDetail.vue